import { AutogenLayoutCycleCode } from "./autogen/AutogenLayoutCycleCode";
import { DuplicateId } from "@mcleod/dispatch";
import { DataSourceAction, DataSourceExecutionEvent, DropdownSelectionEvent } from "@mcleod/components";

export class CycleCode extends AutogenLayoutCycleCode {
    onLoad(): void | Promise<void> {
        DuplicateId.configureIdTextbox(this.textboxId, {
            tableName: "cycle",
            screenName: "Cycle Code",
            navigateToUrl: "lme/settlement/CycleCode?mode=update&key="
        });

        this.mainDataSource.addAfterExecutionListener((event: DataSourceExecutionEvent) => {
            if (event.getAction() === DataSourceAction.SEARCH) {
                this.setRequiredAndEditableFields();
            }
        });
        this.textboxCycleType.addAfterDropdownSelectionListener((event: DropdownSelectionEvent) => {
            if (event.hasSelection()) {
                this.setRequiredAndEditableFields();
            }
        });
    }

    private setRequiredAndEditableFields(): void {
        const isMonthly: boolean = this.activeRow.get("cycle_type") === "M";
        const isSemiMonthly: boolean = this.activeRow.get("cycle_type") === "S";
        const isQuarterly: boolean = this.activeRow.get("cycle_type") === "Q";
        this.textboxMinDate1.required = this.textboxMinDate1.visible = isMonthly || isSemiMonthly
        if (!this.textboxMinDate1.visible) {
            this.textboxMinDate1.clear();
        }
        this.textboxMinDate2.required = this.textboxMinDate2.visible = isSemiMonthly;
        if (!this.textboxMinDate2.visible) {
            this.textboxMinDate2.clear();
        }
        this.textboxQuarterMonth.required = this.textboxQuarterMonth.visible = isQuarterly;
        if (!this.textboxQuarterMonth.visible) {
            this.textboxQuarterMonth.clear();
        }
        this.textboxQuarterDate.required = this.textboxQuarterDate.visible = isQuarterly;
        if (!this.textboxQuarterDate.visible) {
            this.textboxQuarterDate.clear();
        }
    }
}
